// extracted by mini-css-extract-plugin
export default {"header":"styles_header__09dfx","title":"styles_title__DFAO9","subTitle":"styles_subTitle__1hoYh","row":"styles_row__IMVqV"};